import React, { Fragment } from "react";
import { SectionList } from "../components/sections";

import { sections } from "../config";

export const Home = () => (
  <Fragment>
    <SectionList sections={sections} place="UAE"></SectionList>
  </Fragment>
);
